/**
 * =============================================================================
 * Hook: useReferralModuleAvailable
 * Versão: 1.0.0 (Fase 5 — Bloco 5A, item 5.3)
 *
 * Descrição:
 *   Hook simples que indica se o módulo "Indicação" (referral/affiliate) está
 *   habilitado para o tenant atualmente ativo. Lê a flag `affiliate_enabled`
 *   diretamente do `currentTenant` exposto pelo `useAuth`.
 *
 *   - Não dispara nenhuma query adicional: aproveita o estado já carregado.
 *   - Centraliza o ponto de verificação para que telas/menus possam tratar
 *     o módulo como ON/OFF de forma consistente (ModuleSwitcher, sidebars,
 *     guards de rota etc.).
 * =============================================================================
 */
import { useAuth } from '@/hooks/useAuth';

interface UseReferralModuleAvailableReturn {
  /** Indica se o tenant atual possui o módulo Indicação habilitado. */
  isAvailable: boolean;
  /** Replica o estado de carregamento do contexto de auth. */
  loading: boolean;
}

/**
 * Retorna `isAvailable=true` quando o tenant ativo possui `affiliate_enabled=true`.
 * Reaproveita o `useAuth` para evitar fetches duplicados.
 */
export function useReferralModuleAvailable(): UseReferralModuleAvailableReturn {
  const { currentTenant, loading } = useAuth();
  // Fallback defensivo: se o campo ainda não foi carregado, considerar OFF.
  const isAvailable = Boolean((currentTenant as { affiliate_enabled?: boolean } | null)?.affiliate_enabled);
  return { isAvailable, loading };
}
